import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { mediaUrl } from "@/lib/api";
import { useStore } from "@/context/StoreContext";
import { useCurrency } from "@/context/CurrencyContext";
import { TID } from "@/lib/testIds";

const ProductCard = ({ product: p }) => {
  const { saved, toggleSaved } = useStore();
  const { format } = useCurrency();
  const colour = p.colors?.[0] || {};
  const main = colour.lifestyle_image || colour.main_image || colour.images?.[0];
  const alt = colour.back_image || colour.images?.[1];
  const isSaved = saved.includes(p.slug);
  const line = p.department === "men" ? "ORI by Nior Amara" : "Nior Amara";
  const comingSoon = p.status === "coming_soon" || (p.drop_at && new Date(p.drop_at).getTime() > Date.now());

  return (
    <div className="group" data-testid={TID.productCard(p.slug)}>
      <Link to={`/products/${p.slug}`} className="block relative overflow-hidden bg-sand aspect-[3/4]">
        {main ? (
          <>
            <img src={mediaUrl(main)} alt={p.name} loading="lazy"
              className="absolute inset-0 w-full h-full object-contain" />
            {alt && alt !== main && (
              <img src={mediaUrl(alt)} alt={`${p.name} alternate`} loading="lazy"
                className="absolute inset-0 w-full h-full object-contain opacity-0 group-hover:opacity-100 transition-opacity duration-[1200ms] ease-out" />
            )}
          </>
        ) : (
          <span className="absolute inset-0 flex items-center justify-center font-serif text-espresso/45 text-[0.7rem] tracking-[0.18em] uppercase text-center px-3">Imagery arriving soon</span>
        )}
        {comingSoon ? (
          <span data-testid="card-coming-soon" className="absolute top-3 left-3 bg-cocoa text-cream text-[0.58rem] tracking-[0.16em] uppercase px-2.5 py-1">Coming Soon</span>
        ) : p.badges?.[0] ? (
          <span className="absolute top-3 left-3 bg-ivory/85 backdrop-blur-sm text-espresso text-[0.58rem] tracking-[0.16em] uppercase px-2.5 py-1">{p.badges[0]}</span>
        ) : null}
        <button onClick={(e) => { e.preventDefault(); toggleSaved(p.slug); }} data-testid={TID.saveToggle}
          aria-label="Save" className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
          <Heart size={18} strokeWidth={1.3} className={isSaved ? "fill-wine text-wine" : "text-espresso"} />
        </button>
      </Link>
      <Link to={`/products/${p.slug}`} className="block mt-4">
        <p className="text-[0.6rem] tracking-[0.18em] uppercase text-espresso/45">{line}</p>
        <h3 className="font-serif text-lg md:text-xl leading-tight mt-1 group-hover:text-gold transition-colors duration-500">{p.name}</h3>
        <p className="text-sm text-espresso/70 mt-1">{format(p.price)}</p>
      </Link>
    </div>
  );
};

export default ProductCard;
